export enum RequestTypes {
  GET = 'GET',
  POST = 'POST',
  DELETE = 'DELETE',
  PUT = 'PUT',
  PATCH = 'PATCH',
}

export enum ServiceURL {
  // #region Common API

  // Answer Win Services
  GET_ANSWER_WIN_LIST = 'AnswerWin/GetAnswerWin',
  CREATE_ANSWER_WIN = 'AnswerWin/CreateAnswerWin',
  UPDATE_ANSWER_WIN = 'AnswerWin/UpdateAnswerWin',
  DELETE_ANSWER_WIN = 'AnswerWin/DeleteAnswerWin',
  GET_ANSWER_WIN_QUESTION_LIST = 'AnswerWin/GetAnswerWinQuestionList',
  UPDATE_ANSWER_WIN_QUESTION = 'AnswerWin/UpdateAnswerWinQuestion',
  DELETE_ANSWER_WIN_QUESTION = 'AnswerWin/DeleteAnswerWinQuestion',
  UPDATE_ANSWER_WIN_QUESTION_IMAGE = 'AnswerWin/UpdateAnswerWinQuestionImage',
  UPDATE_ANSWER_WIN_QUESTION_ORDER = 'AnswerWin/UpdateAnswerWinQuestionOrder',
  CLONE_ANSWER_WIN = 'AnswerWin/CloneAnswerWin',
  RESET_ANSWER_WIN = 'AnswerWin/ResetAnswerWin',

  // Word Game Services
  CREATE_WORD_GAME = 'WordSearch/CreateWordSearchGame',
  UPDATE_WORD_GAME = 'WordSearch/UpdateWordSearchGame',
  DELETE_WORD_GAME = 'WordSearch/DeleteWordSearchGame',
  GET_WORD_GAME_BY_ID = 'WordSearch/GetWordSearchGameById',
  GET_WORD_SEARCH_GAMES_FOR_ADMIN = 'WordSearch/GetWordSearchGamesForAdmin',

  // Blacklist Services
  GET_BLACKLIST_POST_LIST = 'Blacklist/GetBlacklistedPost',
  UPDATE_BLACKLIST_POST = 'Blacklist/UpdateBlacklist',
  DELETE_BLACKLIST_POST = 'Blacklist/DeleteBlacklistedPosts',
  GET_BLACKLIST_COMMENT_LIST = 'BlackList/GetBlacklistedPostAndPostComments',
  DELETE_BLACKLIST_COMMENT = 'BlackList/DeleteBlacklistedPostComments',
  UPDATE_BLACKLIST_COMMENT = 'BlackList/UpdateBlacklistedPostComments',
  GET_BLACKLIST_RULE_LIST = 'Blacklist/GetBlackList',
  CREATE_BLACKLIST_RULE = 'Blacklist/CreateBlackList',
  UPDATE_BLACKLIST_RULE = 'Blacklist/UpdateBlackListRule',
  DELETE_BLACKLIST_RULE = 'Blacklist/DeleteBlackList',

  // Common Services
  GET_COUNTRY_LIST = 'Country/GetCountryList',
  GET_CITY_LIST = 'City/GetCityList',
  GET_TYPE_LIST = 'Type/GetTypeList',
  REMOVE_CACHE = 'Cache/RemoveCache',
  RE_INDEX_ELASTIC_SEARCH_EMPLOYEES = 'Elastic/Employees/ReIndex',
  RE_INDEX_ELASTIC_SEARCH_POSTS = 'Elastic/Posts/ReIndex',
  GET_MESSAGE_LIST = 'Message/GetMessageList',
  GET_MESSAGE_LIST_EXCEL = 'Message/GetMessageListExcel',
  GET_INTEGRATION_LIST = 'Integrations/List',
  REMOVE_INTEGRATION = 'Integrations/Remove',
  EXCEL_IMPORT_EMPLOYEE = 'Excel/ExcelImportEmployee',
  EXCEL_INSERT_EMPLOYEE = 'Excel/ExcelInsertEmployee',

  // File Services
  GET_FILE_LIST = 'File/GetAllFiles',
  UPLOAD_FILE = 'File/UploadFile',
  DELETE_FILE = 'File/DeleteFile',
  UPDATE_FILE = 'File/UpdateFile',

  // Filter Services
  GET_FILTER_LIST = 'Filter/GetFilterList',
  GET_FILTERS_WITH_CRITERIA = 'Filter/GetFiltersWithCriteria',
  CREATE_FILTER = 'Filter/CreateFilter',
  UPDATE_FILTER = 'Filter/UpdateFilter',
  DELETE_FILTER = 'Filter/DeleteFilter',
  GET_FILTER_BASE_LIST = 'FilterBase/GetFilterBaseList',

  // Hekate Services
  HEKATE_GDPR = 'hekate/gdpr',
  GET_GDPR_CONTENT_LIST = 'hekate/gdprContent/contents',
  GET_GDPR_HISTORY = 'hekate/gdprContent/history',

  // Menu Services
  GET_MENU_LIST = 'Menu/GetMenuList',
  CREATE_MENU = 'Menu/CreateMenu',
  UPDATE_MENU = 'Menu/UpdateMenu',
  DELETE_MENU = 'Menu/DeleteMenu',
  BULK_UPDATE_MENU_ORDER = 'Menu/BulkUpdateMenuOrder',

  // Quote Services
  GET_QUOTE_LIST = 'Quote/GetQuoteList',
  CREATE_QUOTE = 'Quote/CreateQuote',
  UPDATE_QUOTE = 'Quote/UpdateQuote',
  DELETE_QUOTE = 'Quote/DeleteQuote',

  // Popup Notification Services
  GET_POPUP_NOTIFICATION_LIST = 'Popup/GetPopupNotificationList',
  CREATE_POPUP_NOTIFICATION = 'Popup/CreatePopupNotification',
  UPDATE_POPUP_NOTIFICATION = 'Popup/UpdatePopupNotification',
  DELETE_POPUP_NOTIFICATION = 'Popup/DeletePopupNotification',

  // Resource Services
  GET_RESOURCE_LIST = 'Resource/GetResourceAllList',
  GET_RESOURCE_FOR_EDIT = 'Resource/GetResourceForEdit',
  SET_RESOURCE_VALUE = 'Resource/SetResourceValue',
  CLONE_RESOURCE = 'Resource/CloneResource',
  CREATE_RESOURCE = 'Resource/CreateResource',

  // Survey Services
  GET_SURVEY_LIST = 'Survey/GetSurvey',
  CREATE_SURVEY = 'Survey/CreateSurvey',
  UPDATE_SURVEY = 'Survey/UpdateSurvey',
  DELETE_SURVEY = 'Survey/DeleteSurvey',
  GET_SURVEY_QUESTION_GROUP_LIST = 'Survey/GetSurveyQuestionGroup',
  CREATE_SURVEY_QUESTION_GROUP = 'Survey/CreateSurveyQuestionGroup',
  UPDATE_SURVEY_QUESTION_GROUP = 'Survey/UpdateSurveyQuestionGroup',
  DELETE_SURVEY_QUESTION_GROUP = 'Survey/DeleteSurveyQuestionGroup',
  UPDATE_SURVEY_QUESTION = 'Survey/UpdateSurveyQuestion',
  DELETE_SURVEY_QUESTION = 'Survey/DeleteSurveyQuestion',
  CREATE_SURVEY_QUESTION_IMAGE = 'Survey/CreateSurveyImage',
  UPDATE_SURVEY_QUESTION_ORDER = 'Survey/UpdateSurveyQuestionOrder',
  CLONE_SURVEY = 'Survey/CloneSurvey',
  RESET_SURVEY = 'Survey/ResetSurvey',

  // Challenge Services
  GET_CHALLENGE_LIST = 'Challenge/GetChallenges',
  CREATE_CHALLENGE = 'Challenge/CreateChallenge',
  UPDATE_CHALLENGE = 'Challenge/UpdateChallenge',
  DELETE_CHALLENGE = 'Challenge/DeleteChallenge',
  GET_CHALLENGE_TASK_LIST = 'Challenge/GetChallengeTasks',
  CREATE_CHALLENGE_TASK = 'Challenge/CreateChallengeTask',
  UPDATE_CHALLENGE_TASK = 'Challenge/UpdateChallengeTask',
  DELETE_CHALLENGE_TASK = 'Challenge/DeleteChallengeTask',
  REORDER_CHALLENGE_TASK = 'Challenge/ReorderChallengeTask',
  GET_CHALLENGE_TASK_REPORT = 'Challenge/GetChallengeTaskReport',
  GET_CHALLENGE_USER_REPORT = 'Challenge/GetChallengeUserReport',
  GET_CHALLENGE_TASK_REPORT_EXCEL = 'Challenge/GetChallengeTaskReportExcel',
  GET_CHALLENGE_USER_REPORT_EXCEL = 'Challenge/GetChallengeUserReportExcel',

  //#endregion

  // #region Company API

  // Company Services
  GET_COMPANY_INFO = 'Company/GetCompanyList',
  GET_ALL_COMPANY_LIST = 'Company/GetAllCompanyList',
  GET_COMPANY_PUBLIC_INFO = 'Company/GetCompanyPublic',
  CREATE_COMPANY = 'Company/CreateCompany',
  UPDATE_COMPANY = 'Company/UpdateCompany',
  DELETE_COMPANY_BANNER = 'Company/DeleteCompanyBanner',
  DELETE_COMPANY_BACKGROUND = 'Company/DeleteCompanyBackground',
  DELETE_INACTIVE_IMAGE = 'Company/DeleteInactiveImage',
  DELETE_PUSH_LOGO_IMAGE = 'Company/DeletePushLogoImage',
  DELETE_FOURWEEK_IMAGE = 'Company/DeleteFourWeekImage',
  GET_COMPANY_VALUE_LIST = 'CompanyValue/GetCompanyValueList',
  CREATE_COMPANY_VALUE = 'CompanyValue/CreateCompanyValue',
  UPDATE_COMPANY_VALUE = 'CompanyValue/UpdateCompanyValue',
  DELETE_COMPANY_VALUE = 'CompanyValue/DeleteCompanyValue',
  GET_COMPANY_VALUE_GROUP_LIST = 'CompanyValueGroup/GetCompanyValueGroupList',
  CREATE_COMPANY_VALUE_GROUP = 'CompanyValueGroup/CreateCompanyValueGroup',
  UPDATE_COMPANY_VALUE_GROUP = 'CompanyValueGroup/UpdateCompanyValueGroup',
  DELETE_COMPANY_VALUE_GROUP = 'CompanyValueGroup/DeleteCompanyValueGroup',
  GET_COMPANY_IDENTITY_PROVIDER_LIST = 'Company/GetCompanyIdentityProviderList',

  // Holiday Services
  GET_HOLIDAY_LIST = 'Holiday/GetHolidayList',
  CREATE_HOLIDAY = 'Holiday/CreateHoliday',
  UPDATE_HOLIDAY = 'Holiday/UpdateHoliday',
  DELETE_HOLIDAY = 'Holiday/DeleteHoliday',

  // Performance Management Services
  GET_PERFORMANCE_MANAGEMENT_SETTINGS = 'Performance/GetPerformanceSetting',
  UPDATE_PERFORMANCE_MANAGEMENT_SETTINGS = 'Performance/UpdatePerformanceSetting',
  CREATE_COMPANY_OBJECTIVE = 'Performance/CreateCompanyObjective',
  UPDATE_COMPANY_OBJECTIVE = 'Performance/UpdateCompanyObjective',
  GET_COMPANY_OBJECTIVES_LIST = 'Performance/GetCompanyObjectiveList',
  DELETE_COMPANY_OBJECTIVE = 'Performance/DeleteCompanyObjective',
  CREATE_TEAM = 'Performance/CreateTeam',
  UPDATE_TEAM = 'Performance/UpdateTeam',
  GET_TEAM_LIST = 'Performance/GetTeamList',
  DELETE_TEAM = 'Performance/DeleteTeam',
  GET_OBJECTIVE_LIST = 'Performance/GetObjectiveList',
  GET_TEAM_MEMBERS = 'Performance/GetTeamMembers',
  UPDATE_TEAM_MEMBERS = 'Performance/UpdateTeamMembers',
  GET_EMPLOYEE_PROGRESS = 'PerformanceReport/GetEmployeeProgress',
  GET_PERFORMANCE_BEST_TEAM = 'PerformanceReport/GetPerformanceBestTeam',
  GET_PERFORMANCE_BEST_TEAM_EXCEL = 'PerformanceReport/GetPerformanceBestTeamExcel',
  GET_PERFORMANCE_EMPLOYEE_SUCCESS = 'PerformanceReport/GetPerformanceEmployeeSuccess',
  GET_PERFORMANCE_EMPLOYEE_SUCCESS_EXCEL = 'PerformanceReport/GetPerformanceEmployeeSuccessExcel',
  GET_PERFORMANCE_COMPANY_PROGRESS = 'PerformanceReport/GetPerformanceCompanyProgress',
  GET_PERFORMANCE_OBJECTIVE_PROGRESS = 'PerformanceReport/GetPerformanceObjectiveProgress',
  GET_PERFORMANCE_WEEKLY_ITEM_REPORT = 'PerformanceReport/GetPerformanceWeeklyItemReport',
  GET_PERFORMANCE_CARDS = 'PerformanceReport/GetPerformanceReportCards',
  // #endregion

  // #region Message API

  // Announcement Services
  GET_ANNOUNCEMENT_LIST = 'Announcement/GetAnnouncement',
  CREATE_ANNOUNCEMENT = 'Announcement/CreateAnnouncement',
  UPDATE_ANNOUNCEMENT = 'Announcement/UpdateAnnouncement',
  DELETE_ANNOUNCEMENT = 'Announcement/DeleteAnnouncement',
  GET_ANNOUNCEMENT_USER_DISPLAY_LIST = 'Announcement/GetAnnouncementUserDisplay',
  GET_ANNOUNCEMENT_CATEGORY_LIST = 'Announcement/GetAnnouncementCategory',
  CREATE_ANNOUNCEMENT_CATEGORY = 'Announcement/CreateAnnouncementCategory',
  UPDATE_ANNOUNCEMENT_CATEGORY = 'Announcement/UpdateAnnouncementCategory',
  DELETE_ANNOUNCEMENT_CATEGORY = 'Announcement/DeleteAnnouncementCategory',
  GET_ANNOUNCEMENT_REACTIONS = 'Announcement/GetAnnouncementReactions',
  GET_ANNOUNCEMENT_EXCEL = 'Announcement/GetAnnouncementExcel',

  // Message Template Services
  GET_MESSAGE_TEMPLATE_LIST = 'MessageTemplate/GetMessageTemplateList',
  CREATE_MESSAGE_TEMPLATE = 'MessageTemplate/CreateMessageTemplate',
  UPDATE_MESSAGE_TEMPLATE = 'MessageTemplate/UpdateMessageTemplate',
  DELETE_MESSAGE_TEMPLATE = 'MessageTemplate/DeleteMessageTemplate',

  // Notification Services
  GET_NOTIFICATION_SETTING_LIST = 'Notification/GetNotificationSetting',
  GET_NOTIFICATION_SETTING_TEMPLATE_LIST = 'Notification/GetNotificationSettingTemplate',
  SET_NOTIFICATION_SETTING_ACTIVE = 'Notification/SetNotificationSettingActive',
  GET_NOTIFICATION_TEMPLATE_LIST = 'Notification/GetNotificationTemplate',
  CREATE_NOTIFICATION_TEMPLATE = 'Notification/CreateNotificationTemplate',
  UPDATE_NOTIFICATION_TEMPLATE = 'Notification/UpdateNotificationTemplate',
  GET_NOTIFICATION_TEMPLATE_LOCALE = 'Notification/GetNotificationTemplateLocale',
  UPDATE_NOTIFICATION_TEMPLATE_LOCALE = 'Notification/UpdateNotificationTemplateLocale',
  SEND_NOTIFICATION = 'Notification/SendNotification',
  SEND_CUSTOM_PERSONAL_MESSAGE = 'Message/SendCustomPersonalMessage',

  // #endregion

  // #region Post API

  // Community Services
  GET_COMMUNITY_LIST = 'Community/GetCommunityAdmin',
  CREATE_COMMUNITY = 'Community/CreateCommunity',
  UPDATE_COMMUNITY = 'Community/UpdateCommunity',
  DELETE_COMMUNITY = 'Community/DeleteCommunity',
  GET_COMMUNITY_MEMBER_LIST = 'Community/GetCommunityMembers',
  INSERT_COMMUNITY_MEMBER = 'Community/InsertCommunityMember',
  DELETE_COMMUNITY_MEMBER = 'Community/RemoveCommunityMember',
  GET_COMMUNITY_BY_SEARCH = 'Community/GetCommunityBySearch',

  // Post Services
  GET_FRAME_LIST = 'Post/GetFrameList',
  UPDATE_FRAME = 'Post/UpdateFrame',
  GET_POST_LIST = 'Post/GetPostList',
  GET_EMPLOYEE_BY_POST_TYPE = 'Post/GetEmployeeByPostType',
  GET_POST_CARD_LIST = 'Post/GetPostCard',
  CREATE_POST_CARD = 'Post/CreatePostCard',
  UPDATE_POST_CARD = 'Post/UpdatePostCard',
  DELETE_POST_CARD = 'Post/DeletePostCard',
  GET_COMPANY_POST_SETTING_LIST = 'Post/GetCompanyPostSetting',
  CREATE_COMPANY_POST_SETTING = 'Post/CreateCompanyPostSetting',
  UPDATE_COMPANY_POST_SETTING = 'Post/UpdateCompanyPostSetting',
  DELETE_COMPANY_POST_SETTING = 'Post/DeleteCompanyPostSetting',
  DELETE_COMMENT = 'Post/DeletePostComment',
  GET_POST_REPORT_LIST = 'PostReport/GetPostReportList',
  UPDATE_POST_REPORT = 'PostReport/UpdatePostReport',

  // Collage Services
  GET_COLLAGE_LIST = 'PostTemplate/GetPostTemplateList',
  CREATE_COLLAGE = 'PostTemplate/CreatePostTemplate',
  UPDATE_COLLAGE = 'PostTemplate/UpdatePostTemplate',
  DELETE_COLLAGE = 'PostTemplate/DeletePostTemplate',

  // Post Filter Services
  GET_POST_FILTER_LIST = 'PostFilter/GetPostFilterList',
  CREATE_POST_FILTER = 'PostFilter/CreatePostFilter',
  UPDATE_POST_FILTER = 'PostFilter/UpdatePostFilter',
  DELETE_POST_FILTER = 'PostFilter/DeletePostFilter',

  // #endregion

  // #region Point API

  // Order Services
  GET_ORDER_LIST = 'Order/GetOrder',
  UPDATE_ORDER = 'Order/UpdateOrder',
  REVOKE_ORDER = 'Order/RevokeOrder',

  // Reward Services
  GET_REWARD_LIST = 'PointCredit/GetRewardList',
  CREATE_REWARD = 'PointCredit/CreateReward',
  UPDATE_REWARD = 'PointCredit/UpdateReward',
  DELETE_REWARD = 'PointCredit/DeleteReward',
  GET_REWARD_CATEGORY_LIST = 'PointCredit/GetRewardCategoryList',
  CREATE_REWARD_CATEGORY = 'PointCredit/CreateRewardCategory',
  UPDATE_REWARD_CATEGORY = 'PointCredit/UpdateRewardCategory',
  DELETE_REWARD_CATEGORY = 'PointCredit/DeleteRewardCategory',
  GET_SODEXO_REWARD_LIST = 'PointCredit/GetRewardSodexo',

  // Point Credit Services
  GET_POINT_SETTING_LIST = 'PointCredit/GetPointSetting',
  UPDATE_POINT_SETTING = 'PointCredit/UpdatePointSetting',
  GET_POINT_RULE_LIST = 'PointCredit/GetPointRule',
  CREATE_POINT_RULE = 'PointCredit/CreatePointRule',
  DELETE_POINT_RULE = 'PointCredit/DeletePointRule',
  GET_MANUAL_POINT_LIST = 'PointCredit/GetManualPointList',
  CREATE_MANUAL_POINT = 'PointCredit/CreateManualPoint',
  RESET_DISTRIBUTABLE_POINT = 'PointCredit/CreatePointDistributeableReset',
  RESET_SPENDABLE_POINT = 'PointCredit/ResetSpendablePoints',
  GET_POINT_HISTORY = 'PointCredit/GetUserPointHistory',

  // #endregion

  // #region Report API

  // Answer Win Report Services
  GET_ANSWER_WIN_REPORT_EMPLOYEE_BASED = 'AnswerWinReport/GetEmployeeBased',
  GET_ANSWER_WIN_REPORT_QUESTION_BASED = 'AnswerWinReport/GetQuestionBased',
  GET_ANSWER_WIN_REPORT_QUESTION_BASED_DETAIL = 'AnswerWinReport/GetQuestionBasedDetail',
  GET_ANSWER_WIN_REPORT_EMPLOYEE_BASED_EXCEL = 'AnswerWinReport/GetEmployeeBasedExcel',
  GET_ANSWER_WIN_REPORT_QUESTION_BASED_EXCEL = 'AnswerWinReport/GetQuestionBasedExcel',

  // Dashboard Services
  GET_MOST_INTERACTIVE_EMPLOYEE_REPORT = 'Dashboard/GetMostInteractiveEmployee',
  GET_EMPLOYEES_INTERACTING_BY_DEPARTMENTS_REPORT = 'Dashboard/GetEmployeesInteractingByDepartments',
  GET_POST_SUMMARY = 'Dashboard/GetPostSummary',
  GET_COMPANY_VALUE_REPORT = 'Dashboard/GetCompanyValue',
  GET_SPENT_POINT_REPORT = 'Dashboard/GetSpentPoint',
  GET_ENGAGEMENT_SUMMARY = 'Dashboard/GetEngagementSummary',
  GET_SIGNED_IN_USERS_REPORT = 'Dashboard/GetSignedInUsers',
  GET_EMPLOYEES_EARN_POINT_SUMMARY = 'Dashboard/GetPointEmployeesEarnSummary',
  GET_POST_TYPE_REPORT = 'Dashboard/GetPostTypesPie',
  GET_PORTAL_LOGIN_REPORT = 'Dashboard/GetPortalLoginReport',
  GET_PORTAL_LOGIN_REPORT_EXCEL = 'Dashboard/GetPortalLoginReportExcel',
  GET_ACCESS_REPORT = 'Dashboard/GetAccessReport',
  GET_TEMPORAL_CHANGE_REPORT = 'Dashboard/GetTemporalChangeReport',
  GET_ACCESS_REPORT_EXCEL = 'Dashboard/GetAccessReportExcel',
  GET_TEMPORAL_CHANGE_REPORT_EXCEL = 'Dashboard/GetTemporalChangeReportExcel',
  GET_MOBILE_SIGNED_REPORT = 'Dashboard/GetMobileSignedInUsers',

  // Point Report Services
  GET_POINT_REPORT = 'PointReport/GetPointReport',
  GET_POST_DETAIL_REPORT = 'PointReport/GetPostDetail',
  GET_SPENDABLE_POINT_REPORT = 'PointReport/GetPointSpendable',
  GET_DISTRIBUTABLE_POINT_REPORT = 'PointReport/GetPointDistributable',
  GET_POINT_RESET_REPORT = 'PointReport/GetPointResetReport',
  GET_POINT_REPORT_EXCEL = 'PointReport/GetPointReportExcel',
  GET_POST_DETAIL_REPORT_EXCEL = 'PointReport/GetPostDetailExcel',
  GET_SPENDABLE_POINT_REPORT_EXCEL = 'PointReport/GetPointSpendableExcel',
  GET_SPENDABLE_POINT_REPORT_DETAIL_EXCEL = 'PointReport/GetPointSpendableDetailExcel',
  GET_DISTRIBUTABLE_POINT_REPORT_EXCEL = 'PointReport/GetPointDistributableExcel',
  GET_DISTRIBUTABLE_POINT_REPORT_DETAIL_EXCEL = 'PointReport/GetPointDistributableDetailExcel',
  GET_POINT_RESET_REPORT_EXCEL = 'PointReport/GetPointResetReportExcel',

  // Report Services
  GET_COMMUNITY_REPORT = 'CommunityReport/GetCommunityReport',
  GET_COMMUNITY_REPORT_EXCEL = 'CommunityReport/GetCommunityReportExcel',
  GET_EMPLOYEE_REWARD_REPORT = 'EmployeeRewardReport/GetEmployeeRewardReport',
  GET_EMPLOYEE_REWARD_REPORT_EXCEL = 'EmployeeRewardReport/GetEmployeeRewardReportExcel',
  GET_EMPLOYEE_GIFT_REPORT = 'EmployeeGiftReport/GetEmployeeGiftReport',
  GET_EMPLOYEE_GIFT_REPORT_EXCEL = 'EmployeeGiftReport/GetEmployeeGiftReportExcel',
  GET_POST_REPORT_BY_DIVISION = 'PostReport/GetPostReportByDivision',
  GET_POST_REPORT_BY_DIVISION_EXCEL = 'PostReport/GetPostReportByDivisionExcel',
  GET_ABUSE_REPORT = 'PostReport/GetAbuseReport',
  GET_ABUSE_REPORT_EXCEL = 'PostReport/GetAbuseReportExcel',
  GET_ENGAGEMENT_REPORT = 'PostReport/GetEngagementReport',
  GET_ENGAGEMENT_REPORT_EXCEL = 'PostReport/GetEngagementReportExcel',
  GET_COMMENT_REPORT = 'PostReport/GetCommentReport',
  GET_COMMENT_REPORT_EXCEL = 'PostReport/GetCommentReportExcel',

  // Survey Report Services
  GET_SURVEY_REPORT = 'SurveyReport/GetSurveyReport',
  GET_SURVEY_REPEATABLE_REPORT = 'SurveyReport/GetSurveyRepeatableReport',
  GET_SURVEY_REPEATABLE_REPORT_EXCEL = 'SurveyReport/GetSurveyRepeatableReportExcel',
  GET_SURVEY_ANSWER_BY_USER_EXCEL = 'SurveyReport/GetSurveyAnswerByUserExcel',

  // Tier Report Services
  GET_TOP_TIER_REPORT_BY_CONTENT = 'TopTierReport/GetTopTierReportByContent',
  GET_TOP_TIER_REPORT_BY_DAYS = 'TopTierReport/GetTopTierReportByDays',
  GET_TOP_TIER_REPORT_BY_HOURS = 'TopTierReport/GetTopTierReportByHours',
  GET_TOP_TIER_REPORT_BY_PERSON = 'TopTierReport/GetTopTierReportByPerson',
  GET_TOP_TIER_REPORT_BY_DEPARTMENT = 'TopTierReport/GetTopTierReportByDepartment',
  GET_TOP_TIER_REPORT_BY_LOCATION = 'TopTierReport/GetTopTierReportByLocation',
  GET_TOP_TIER_REPORT_BY_CATEGORY = 'TopTierReport/GetTopTierReportByCategory',
  GET_TOP_TIER_REPORT_BY_CITY = 'TopTierReport/GetTopTierReportByCity',
  GET_TOP_TIER_REPORT_BY_EMPLOYEE_WORKER_TYPE = 'TopTierReport/GetTopTierReportByWorkerType',
  GET_TOP_TIER_REPORT_BY_CONTENT_EXCEL = 'TopTierReport/GetTopTierReportByContentExcel',
  GET_TOP_TIER_REPORT_BY_DAYS_EXCEL = 'TopTierReport/GetTopTierReportByDaysExcel',
  GET_TOP_TIER_REPORT_BY_HOURS_EXCEL = 'TopTierReport/GetTopTierReportByHoursExcel',
  GET_TOP_TIER_REPORT_BY_PERSON_EXCEL = 'TopTierReport/GetTopTierReportByPersonExcel',
  GET_TOP_TIER_REPORT_BY_DEPARTMENT_EXCEL = 'TopTierReport/GetTopTierReportByDepartmentExcel',
  GET_TOP_TIER_REPORT_BY_LOCATION_EXCEL = 'TopTierReport/GetTopTierReportByLocationExcel',
  GET_TOP_TIER_REPORT_BY_CATEGORY_EXCEL = 'TopTierReport/GetTopTierReportByCategoryExcel',
  GET_TOP_TIER_REPORT_BY_CITY_EXCEL = 'TopTierReport/GetTopTierReportByCityExcel',
  GET_TOP_TIER_REPORT_BY_EMPLOYEE_WORKER_TYPE_EXCEL = 'TopTierReport/GetTopTierReportByWorkerTypeExcel',

  // Word Game Report Services
  GET_WORD_GAME_REPORT = 'WordSearchReport/GetWordSearchReport',
  GET_WORD_GAME_REPORT_EXCEL = 'WordSearchReport/GetWordSearchReportExcel',

  // #endregion

  // #region User API

  // Department Services
  GET_DEPARTMENT_LIST = 'Department/GetDepartmentList',
  CREATE_DEPARTMENT = 'Department/CreateDepartment',
  UPDATE_DEPARTMENT = 'Department/UpdateDepartment',
  DELETE_DEPARTMENT = 'Department/DeleteDepartment',

  // Employee Services
  GET_EMPLOYEE_LIST = 'Employee/GetEmployeeList',
  GET_EMPLOYEE_LIST_BY_FILTER = 'Employee/GetEmployeeListByFilter',
  CREATE_EMPLOYEE = 'Employee/CreateEmployee',
  UPDATE_EMPLOYEE = 'Employee/UpdateEmployee',
  DELETE_EMPLOYEE = 'Employee/DeleteEmployee',
  ANONYMIZE_EMPLOYEE = 'Employee/AnonymizeEmployee',
  GET_EMPLOYEE_BY_ID_WEB = 'Employee/GetEmployeeByIdWeb',
  GET_BORDERED_EMPLOYEE_LIST = 'Employee/GetBorderedEmployeeList',
  UPDATE_EMPLOYEE_BORDERS = 'Employee/UpdateEmployeeBorders',

  // Employee Type Services
  GET_EMPLOYEE_TYPE_LIST = 'EmployeeWorkerType/GetEmployeeWorkerType',
  CREATE_EMPLOYEE_TYPE = 'EmployeeWorkerType/CreateEmployeeWorkerType',
  UPDATE_EMPLOYEE_TYPE = 'EmployeeWorkerType/UpdateEmployeeWorkerType',
  DELETE_EMPLOYEE_TYPE = 'EmployeeWorkerType/DeleteEmployeeWorkerType',

  // Location Services
  GET_LOCATION_LIST = 'Location/GetLocation',
  CREATE_LOCATION = 'Location/CreateLocation',
  UPDATE_LOCATION = 'Location/UpdateLocation',
  DELETE_LOCATION = 'Location/DeleteLocation',

  // Position Services
  GET_POSITION_LIST = 'Position/GetPositionList',
  CREATE_POSITION = 'Position/CreatePosition',
  UPDATE_POSITION = 'Position/UpdatePosition',
  DELETE_POSITION = 'Position/DeletePosition',

  // Level Services
  GET_LEVEL_LIST = 'Level/GetLevelList',
  CREATE_LEVEL = 'Level/CreateLevel',
  UPDATE_LEVEL = 'Level/UpdateLevel',
  DELETE_LEVEL = 'Level/DeleteLevel',

  // Role Services
  GET_PERMISSION_BY_JWT = 'Role/GetPermissionByJwt',
  GET_ROLE_GROUP_LIST = 'Role/GetRoleGroup',
  GET_PERMISSION_LIST = 'Role/GetPermission',
  SET_PERMISSION = 'Role/SetPermission',

  // Self Registration Services
  GET_SELF_REGISTRATION_LIST = 'SelfRegistration/GetSelfRegistrationList',
  CREATE_SELF_REGISTRATION = 'SelfRegistration/CreateSelfRegistration',
  UPDATE_SELF_REGISTRATION = 'SelfRegistration/UpdateSelfRegistration',
  REGENERATE_SELF_REGISTRATION_TOKEN = 'SelfRegistration/RegenerateSelfRegistrationToken',
  DELETE_SELF_REGISTRATION = 'SelfRegistration/DeleteSelfRegistration',
  GET_SELF_REGISTRATION_USER_LIST = 'SelfRegistration/GetSelfRegistrationUserList',

  // User Services
  GET_USER_LIST = 'User/GetUserList',
  GET_USER_LIST_BY_FILTER = 'User/GetUserListByFilter',
  SEND_ACTIVATION_MESSAGE = 'User/SendActivationMessage',
  RESET_PASSWORD = 'User/ResetPassword',
  RENEW_PASSWORD = 'User/RenewPassword',
  GET_IS_SECURELY_PASSWORD = 'User/GetIsSecurlyPassword',
  MFA_CHECK = 'User/MFACheck',
  GET_ENTRA_ID = 'User/GetEntraId',
  GET_USER_LIST_EXCEL = 'User/GetUserListReportExcel',
  GET_ACTIVE_USER_COUNT = 'User/GetActiveUserCount',
  GET_RESET_PASSWORD_LINK = 'User/GetPasswordResetLink',
  LOGIN = 'Login/Login',
  LOGOUT = 'Login/Off',
  REFRESH_TOKEN = 'Login/RefreshToken',

  // #endregion
}
